import { useContext } from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

import { DataContext } from '../contexts/DataContext';
import { Box } from '@mui/material';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export default function CustomizedDialog() {
  const dataCtx = useContext(DataContext);

  const handleClose = () => {
    dataCtx.handleDialogClose();
  };

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={dataCtx.dialogOpen}
      fullWidth>
      <Box
      // sx={{
      //   '@media (orientation: portrait) and (max-width: 600px)': {
      //     minWidth: '80vw',
      //   },
      //   '@media (orientation: portrait) and (min-width: 600px)': {
      //     minWidth: '70vw',
      //   },
      //   '@media (orientation: landscape)': {
      //     minWidth: '50vw',
      //   },
      // }}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          {dataCtx.dialogData.title}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}>
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>{dataCtx.dialogData.content}</DialogContent>
        {/* <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Save changes
          </Button>
        </DialogActions> */}
      </Box>
    </BootstrapDialog>
  );
}
